define('views/modules/calendar/nutrition/food/recipe/recipe-content',[
    // Libs
    'require', 'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    'services/events/nutrition-events',
    // models & collections
    'collections/calendar/nutrition/entries',
    'models/calendar/nutrition/serving',
    // views
    'src/views/form-view',
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/nutrition/food/details/details-form',
    'views/modules/calendar/nutrition/entry/food-entry-list',
    'views/modules/calendar/nutrition/nutrient/nutrient-report',
    // templates
    'text!templates/modules/calendar/nutrition/food/recipe/recipe-content.html'

], function(
    // Libs
    require, _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    NutritionEvents,
    // models & collections
    CFoodEntries,
    MServing,
    // Views
    VForm,
    VMenuSaveAction,
    VFoodDetailsForm,
    VFoodEntryList,
    VNutrientReport,
    // Template
    TRecipeContent
) {

    var VRecipeContent = VForm.extend({
        template: TRecipeContent,
        regions: {
            root: ".nutrition-edit-content",
            menu: ".menu-actions",
            form: ".food-details-form",
            list: ".nutrition-day-log",
            report: ".nutrition-daily-report"
        },

        initialize: function() {
            var model = this.model,
                collection = this.collection = new CFoodEntries(null, { hour: false }),
                serving = this.serving = new MServing(),
                actions = this.actionCollection = new Backbone.Collection([
                    { title: 'Add food to this recipe', itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddFoodAction },
                ]),
                view = this.view = {
                    menu: new VMenuSaveAction({
                        context: this,
                        radio: false,
                        collection: actions,
                        onClick: this.onActionClick,
                        onSave: this.onSave,
                        tooltip: {
                            container: this.regions.root,
                        }
                    }),
                    form: new VFoodDetailsForm({
                        model: model,
                        serving: serving,
                    }),
                    list: new VFoodEntryList({
                        title: "Ingredients",
                        collection: collection,
                        date: false,
                        foodCheck: false,
                        caller: 'recipe',
                    }),
                    report: new VNutrientReport({
                        collection: collection,
                        eatenFoodsOnly: false,
                    }),
                };

            this.resetCollection();

            this.listenTo(model, {
                'model:reset': this.onModelReset,
                'change': this.onModelChange,
            });

            this.listenTo(collection, { 'update change entry:add': this.onEntryListChange });
            this.listenTo(view.list, 'add:food', this.onAddFoodAction);
        },

        render: function() {
            this.initListener();
            var html = Mustache.render(this.template, Mustache.getContext());
            this.$el.empty().append(html);

            this.generateZones();
            var view = this.view,
                zone = this.zone;
            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form)
                .assign(view.list, zone.$list)
                .assign(view.report, zone.$report);

            if (!Viewport.isMobile()) {
                this.toggleFoodPanel(true);
            }

            return this;
        },

        initListener: function() {
            this.stopListeningTo(NutritionEvents);
            this.listenTo(NutritionEvents, { 'recipeFood:add': this.onRecipeFoodAdd, });
        },

        toggleFoodPanel: function(val, model) {
            var view = this.view,
                VFoodPanel = require('views/modules/calendar/nutrition/food/food-panel'),
                foodView = view.food || (view.food = new VFoodPanel({ recipe: false, suggestion: false, }));

            if (model) foodView.setModel(model);

            this.trigger('drawer:view', foodView, val);
        },

        updateSaveButton: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        resetCollection: function() {
            var collection = this.collection;
            collection.reset(this.model.getEntries());
            this.collectionCopy = collection.toJSON({ blacklist: true });
        },

        isDirty: function() {
            return VRecipeContent.__super__.isDirty.call(this) || this.hasCollectionChanged();
        },

        /////////////
        // actions //
        /////////////
        onRecipeFoodAdd: function(foods) {
            console.log('adding food to recipe');
            var view = this.view.list;
            _.each(foods, function(model) {
                //this.foodReceptor.addEntry(model);
                view.addEntry(model);
            }, this);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },
        onAddFoodAction: function() {
            this.toggleFoodPanel(true);
        },

        onAddToFavoriteAction: function() {

        },
        ////////////
        // events //
        ////////////

        onNutritionEdit: function(model) {
            this.toggleFoodPanel(true, model);
        },

        onModelReset: function(model, options) {
            this.resetCollection();
        },

        onModelChange: function(model, options) {
            this.updateSaveButton();
        },

        onEntryListChange: function() {
            this.updateSaveButton();
        },

        onValidate: function() {
            var result = this.collection.isValid();
            if (!result) {
                this.collection.each(function(model) {
                    if (model.validationError) U.warn(model.validationError);
                });
            }
            return result;
        },

        onSubmit: function() {
            if (this.hasCollectionChanged()) {
                this.model.setEntries(this.collection.toJSON({ blacklist: true }));
            }

            var serving = this.serving.toJSON();
            serving.nutrients = this.collection.getTotalNutrients();
            this.model.setServing(serving);
        },

        onSave: function() {
            this.submit();
        },

    });

    return VRecipeContent;

});

